export default "__VITE_ASSET__DjJlZt6i__"